export default __webpack_public_path__ + "static/media/Daily-Bread.b0882b31.jpeg";